<template>
<v-container v-if="club">
  <div class="resumen_tournament">
    <v-row>
      <v-col>
    <div class="pt-3"> {{club.name}} </div>
      </v-col>
    </v-row>
    <v-row>
  </v-row>
  </div>
<div>

<br>
  <v-row>
  <v-col cols="6">
    <p class="text-center pb-4" style="font-size:25px;">Entradas</p>
  <v-table density="compact">
    <thead>
      <tr>
        <th class="text-center">
          Nombre
        </th>
        <th class="text-center">
          Club Origen
        </th>
        <th class="text-center">
          Estado
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="item in club.entry_person"
        :key="item.id"
      >
        <td class="text-left"><a :href="'/player/'+item.person.id" target="_blank" style="color:blue">{{ item.person.full_name }}</a></td>
        <td class="text-left">
            {{ item.from_club.name }}
        </td>
         <td class="text-left">
          <p v-if="item.status == 'A'">Aceptado</p>
          <p v-else-if="item.status == 'R'">Rechazado</p>
          <p v-else>Pendiente</p>
        </td>
      </tr>
    </tbody>
  </v-table>
    </v-col>
    <v-col cols="6">
      <p class="text-center pb-4" style="font-size:25px;">Salidas</p>
  <v-table density="compact">
    <thead>
      <tr>
        <th class="text-center">
          Nombre
        </th>
        <th class="text-center">
          Destino
        </th>
        <th class="text-center">
          Estado
        </th>
      </tr>
    </thead>
    <tbody>
      <tr
        v-for="item in club.exit_person"
        :key="item.id"
      >
        <td class="text-left">
    <!-- Enlace que al hacer clic abre el modal en lugar de redireccionar -->
        <a v-if="item.status == 'P'" @click.prevent="openModal(item)" style="color:blue; cursor: pointer;">
          {{ item.person.full_name }}
        </a>
          <a v-else :href="'/player/'+item.person.id" target="_blank" style="color:blue">{{ item.person.full_name }}</a>
  </td>
        <td class="text-left">
            {{ item.to_club.name }}
        </td>
         <td class="text-left">
          <p v-if="item.status == 'A'">Aceptado</p>
          <p v-else-if="item.status == 'R'">Rechazado</p>
          <p v-else>Pendiente</p>
        </td>
      </tr>
    </tbody>
  </v-table>
    </v-col>
    </v-row>
  </div>

  <v-dialog v-model="dialog" persistent="false" max-width="600px">
    <v-card v-if="person_select">
      <v-card-title>
        <span class="headline">Razón</span>
      </v-card-title>
      <v-card-text>
        <v-container>
          <v-form>
            <!-- Campo de texto para la razón -->
            <v-text-field
              v-model="reason"
              label="Razón"
              required
            ></v-text-field>
          </v-form>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <!-- Botones para aceptar y rechazar -->
        <v-spacer></v-spacer>
        <v-btn color="green darken-1" text @click="accept">
          Aceptar
        </v-btn>
        <v-btn color="red darken-1" text @click="reject">
          Rechazar
        </v-btn>
        <v-btn color="grey darken-1" text @click="dialog = false">
          Cerrar
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</v-container>

</template>
<script>

import {mapState} from "vuex";
import gql from "graphql-tag";
import axios from "axios";
export default {
  apollo: {
    club: {query: gql` query($id:String!){
       club:seeClub(id:$id){
        id
        name
        entry_count:entryCount
        exit_count:exitCount
        entry_person:entryPerson{
          id
          status
          from_club:fromClub{
            name
          }
          person{
            id
            full_name:fullNameEnglish
            canon
            federation_id:federationId
          }
        }
        exit_person:exitPerson{
          id
          status
          to_club:toClub{
            name
          }
          person{
            id
            full_name:fullNameEnglish
            canon
            federation_id:federationId
          }
        }
      }
    }`,
      variables() {return {"id" :this.id}}
    },
  },
  props:['id'],
    name:"SeeNewsChess",
  data() {

    return {
      dialog:false,
      person_select:null,
      a:'',
      club: null,
      reason:'',
    }
  },
  computed: {
    ...mapState(['is_authenticated']),
  },
  methods: {
    openModal(person) {
      this.reason = '';
      this.person_select = person; // Asigna la persona seleccionada
      this.dialog = true;           // Abre el modal
    },
    onChange() {
      console.log("this.conktent",this.content)
    },
    accept() {
      // Lógica para aceptar
      console.log("Aceptado con la razón:", this.reason);
      this.sendRequest('1')
    },
    reject() {
      // Lógica para rechazar
      console.log("Rechazado");
      this.sendRequest('0')
    },
    sendRequest(option){
      axios.post('/edit_request/'+this.person_select.id+'/'+option+'/',{reason:this.reason}).then(() => {
          window.location.href = "/cambios_club/" + this.id

      })
      .catch(error => {
        alert("Hubo Problemas")
        console.log(error)
      })
    },
    uploadCallback(url) {
      console.log('uploaded url', url)
    },
    handleStatusChange(item) {
      const url = '/update_model_inscription/';
      // Aquí puedes manejar el cambio de estado, por ejemplo, hacer una llamada API para actualizar el estado en tu servidor.
      console.log('Status changed for inscription', item.status);
      axios.post(url, item).then(() => {
        alert("cambio aplicado con exito")
      })
      .catch(error => {
        alert("datos ingresados no validos")
        console.log(error)
      })
    },
  },
}
</script>
<style>
.resumen_tournament{
  font-family: Montserrat;
font-size: 30px;
font-weight: 600;
line-height: 37px;
letter-spacing: 0em;
text-align: left;
color: #F4F4F4;
  background-color:#2A4558;
  text-align: center;

}
@media (max-width: 600px) {
  .resumen_tournament{
    font-size: 24px;
  }
}
</style>
